export const showAlert = (type, message) => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_ALERT_SHOW",
      payload: true,
    });
    dispatch({
      type: "UPDATE_ALERT_TYPE",
      payload: type,
    });
    dispatch({
      type: "UPDATE_ALERT_MESSAGE",
      payload: message,
    });
  };
};

export const closeAlert = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_ALERT_SHOW",
      payload: false,
    });
    dispatch({
      type: "UPDATE_ALERT_TYPE",
      payload: "",
    });
    dispatch({
      type: "UPDATE_ALERT_MESSAGE",
      payload: "",
    });
  };
};
